import { observer } from "owa-mobx-react";
import { container } from "./HelpPane.scss";
import { useHelpUrl } from "../hooks/useHelpUrl";
import { OWAIframe } from "owa-iframe";
import type { FunctionComponent } from "react";

const defaultExport: FunctionComponent<{}> = observer(function HelpPane() {
    const src = useHelpUrl();
    
    return (<OWAIframe isVisible={true} scenario="HelpPane" src={src} className={container} sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation"/>);
}, "HelpPane");
export default defaultExport;
